<template>
	<div class="over-auto nav box-s">
		<ul class="flexs fz-14 c1" >
			<li class="ptb-18-12 every_nav pr" :class="{ 'active': activeIndex == index }" v-for="(item, index) in navList" :key="index" @click="getIndex(index, item)">
        {{item.id?item.title || item.subject_name:item}}
        <div class="nav_line" v-if="activeIndex == index"></div>
      </li>
		</ul>
	</div>
</template>
<script>
	export default {
		props: {
			navList: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
        activeIndex: 0
			}
		},
    created(){
    },
		mounted() {},
		methods: {
      getIndex(index, item){
        this.activeIndex = index
        this.$emit('getItem', {item, index})
      }
		}
	}
</script>
<style lang="less" scoped>
.nav_line {
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  width: 26px;
  height: 2px;
  background: #497CFF;
  border-radius: 1px;
}

.active {
  font-size: 15px;
  font-weight: 500;
  color: #497CFF;
}
.every_nav {
  white-space:nowrap;
  flex-shrink: 0;
  padding: 18px 20px 12px;
}
// .every_nav:last-child {
//   padding-right: 20px;
// }

.nav::-webkit-scrollbar{
    display: none;
}

</style>
